export enum PreferredFreelancerBadgeType {
  PREFERRED_FREELANCER = 'preferred-freelancer.svg',
  PREFERRED_ARROW_FREELANCER = 'arrow-preferred-freelancer-v2.svg',
}
